<template>
	<li>
		<div class="hoverable">
			<div
				:class="{bold: isFolder, notBold: !isFolder}"
				@click="toggle">
				<template v-if="isFolder">
					<i v-if="!open" class="fa fa-building"></i>
					<i v-else-if="open" class="fa fa-building-o"></i>
				</template>
				<template v-else>
					<i class="fa fa-building-o"></i>
				</template>
				{{ model ? model.name : '' }}
			</div>
			<div id="hoveredIcons" :style="deleteHoverStyle" style="margin-left: 2em;">
				<i @click="$emit('showRefModal', {dep: model, forAdding: true})"
				   class="fa fa-plus-circle add"
				   v-if="$can('create/edit', 'department')"
				></i>

				<i @click="$emit('showRefModal', {dep: model, forAdding: false})"
				   v-b-tooltip.hover
				   title="Referenceni o'zgartirish"
				   class="fa fa-edit edit"
				   v-if="$can('create/edit', 'department')"
				></i>

				<i
					v-if="$can('delete', 'department')"
					@click="onOpen(model.id)"
					class="fa fa-trash delete"
					:id="'popOverDelete'+model.id"
				></i>
			</div>

			<b-popover
				:key="model.id + 'popover'"
				:target="'popOverDelete'+model.id"
				placement="auto"
				container="myContainer"
				:ref="'popover'+model.id"
				id="popoverId"
				class="refDeleteConfirm"
			>
				<template slot="title">
					<b-button @click="onClose(model.id)" class="close" aria-label="Close"
							  style="margin-left: 5px">
						<span class="d-inline-block" aria-hidden="true">&times;</span>
					</b-button>
					{{$t('want_to_delete?')}}
				</template>

				<div>
					<div class="row mt-1">
						<div class="col-6">
							<b-button variant="outline-danger" size="sm" block
									  @click="onClose(model.id)">Yo'q
							</b-button>
						</div>
						<div class="col-6">
							<b-button variant="outline-success" size="sm" block
									  @click="onOk(model.id)">Ha
							</b-button>
						</div>
					</div>
				</div>
			</b-popover>
		</div>

		<ul v-show="open" v-if="isFolder">
			<tree-view
				@showRefModal="emitShowRefModal"
				@deleteDep="emitDeleteDepartment"
				class="item"
				v-for="(childModel, index) in model.children ? model.children : []"
				:key="index + 'depChild'"
				:model="childModel">
			</tree-view>
		</ul>
	</li>
</template>

<script>
	import Vue from 'vue'
	export default {
		name: "TreeView",
		props: [
			'model'
		],
		data: function () {
			return {
				open: true,
				hoverState: false
			}
		},
		computed: {
			deleteHoverStyle: function() {
				if (this.hoverState) {
					return {
						'visibility': 'visible'
					};
				} else {
					return {}
				}

			},
			isFolder: function () {
				return this.model ? (this.model.children &&
					this.model.children.length) : ([] && 0)
			}
		},
		methods: {
			onOpen(itemId) {
				this.hoverState = true;
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('open')
			},
			onClose(itemId) {
				this.hoverState = false;
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			async onOk(itemId) {
				this.onClose(itemId)
				await this.$emit('deleteDep', itemId);
			},
			emitShowRefModal (depAndForAdding) {
				this.$emit('showRefModal', depAndForAdding)
			},
			emitDeleteDepartment (id) {
				this.$emit('deleteDep', id)
			},
			toggle: function () {
				if (this.isFolder) {
					this.open = !this.open
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	ul {
		padding-left: 1.7em !important;
		line-height: 1.5em;
		list-style-type: none;
	}
	#hoveredIcons {
		visibility: hidden;
		display: inline-block;
	}
	li>div {
		&:hover {
			#hoveredIcons {
				display: inline-block !important;
				visibility: visible !important;
				margin: 0;
			}
		}
	}
	li div div:first-child, .add, .delete, .edit {
		display: inline-block;
		cursor: pointer;
		margin: 8px 0;
	}
	li div div:first-child {
		&:hover {
			text-decoration: underline;
		}
	}
	li .bold {
		font-weight: bold;
	}
	.fa {
		margin-right: .8em;
	}
	.fa-building, .fa-building-o {
		color: #F0D45F;
	}

</style>
